export default "__VITE_ASSET__4d29ac98__"